import type { EntryKind } from "@/types";

/** Accepts exporter values `expense` / `gain` (trimmed). */
export function parseCsvEntryKind(raw: string): EntryKind | null {
  const v = raw.trim().toLowerCase();
  if (v === "expense" || v === "gain") return v;
  return null;
}
